<!-- 教练列表管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex">
        <div class="text">教练管理</div>
        <el-button @click="addShopBut" round type="primary" size="small"
          >添加教练</el-button
        >
      </div>
      <div class="content ">
        <el-table
          height="68vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="FitnessCoachobj.list"
          style="width: 100%"
        >
          <el-table-column prop="id" label="账号 id" width="210">
          </el-table-column>
          <el-table-column prop="name" label="教练名字" width="210">
          </el-table-column>
          <el-table-column prop="name" label="绑定手机号" width="210">
          </el-table-column>
          <el-table-column label="教练价格" width="210">
            <template slot-scope="scope"> {{ scope.row.price }} 元 </template>
          </el-table-column>
          <el-table-column prop="adRegister" label="登录时间" width="230">
          </el-table-column>
          <el-table-column label="教练评价">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >查看</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="编辑">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >修改</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                @confirm="delBut(scope.row)"
                title="这是一段内容确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ FitnessCoachobj.total }}条记录，</span>
            <span class="pageNum">{{ FitnessCoachobj.pageNum }}</span>
            <span>/{{ FitnessCoachobj.pages }}页</span>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="FitnessCoachobj.pageNum"
            :page-size="FitnessCoachobj.pageSize"
            layout="prev, pager, next, jumper"
            :total="FitnessCoachobj.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="dialog">
      <el-dialog
        :modal-append-to-body="false"
        :visible.sync="dialogAdmin"
        width="30%"
        :before-close="dialogAdminClose"
      >
        <span slot="title">
          <span class="header-main-title">{{ dialogTitle }}</span>
        </span>
        <div class="adminForm textalignLeft">
          <el-form ref="adminForm" :model="adminForm" label-width="80px">
            <el-form-item label="用户名">
              <el-input v-model="adminForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机账号">
              <el-input v-model="adminForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" v-if="!isEdit">
              <el-input v-model="adminForm.Password"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址">
              <el-input v-model="adminForm.email"></el-input>
            </el-form-item>
            <el-form-item label="可用状态">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                v-model="adminForm.activate"
              ></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogAdmin = false">取 消</el-button>
          <el-button type="primary" @click="dialogAdminBut">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { apiFitnessCoach } from '@/api/fitness'

export default {
  name: '',
  props: [''],
  data() {
    return {
      FitnessCoachobj: '', // 获取分页数据
      page: '1', // 页数
      dialogAdmin: false,
      dialogTitle: '',
      isEdit: false, // 判断是否为修改管理员
      adId: '', // 管理员id
      adminForm: {
        name: '',
        tel: '',
        Password: '',
        activate: 0
      },
      adminFormEmail: '',
      adminFormList: ['姓名不能为空！', '手机账号不能为空！', '密码不能为空！']
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.FitnessCoach()
  },

  methods: {
    // 新增管理员
    addShopBut() {
      //   this.dialogTitle = '新增管理员'
      //   this.dialogAdmin = true
      this.$router.push({
        path: '/addCoaches'
      })
    },
    // 列表删除
    delBut(row) {
      console.log(row)
    },
    // 列表修改
    editBut(row) {
      console.log(row)
      this.isEdit = true
      this.adId = row.adId
      this.adminForm.name = row.adName
      this.adminForm.tel = row.adUname
      this.adminForm.activate = row.adActivate
      this.adminFormEmail = row.adEmail
      this.dialogTitle = '修改管理员'
      this.dialogAdmin = true
    },
    // 弹窗：新增/修改管理员确定
    dialogAdminBut() {
      if (!this.dialogAdmin) {
        if (!this.objNaN(this.adminForm, this.adminFormList)) {
        }
      } else if (this.dialogAdmin) {
        switch (true) {
          case !this.adminForm.name:
            this.$message.error('名字不能为空！')
            break
          case !this.adminForm.tel:
            this.$message.error('手机号不能为空！')
            break
          default:
        }
      }
    },

    // 弹窗关闭回调
    dialogAdminClose(e) {
      this.dialogAdmin = false
      this.isEdit = false
      this.adminForm = {
        name: '',
        tel: '',
        Password: '',
        activate: 0
      }
      this.adminFormEmail = ''
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val
      console.log(`当前页: ${val}`)
      this.GetAdminList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    // 接口
    // 分页查询全部教练
    FitnessCoach() {
      apiFitnessCoach({
        page: this.page,
        pageSize: 20,
        status: 0
      }).then(res => {
        if (res.status === 0) {
          this.FitnessCoachobj = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
